import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { Spinner } from '@/Domain/components/Shared/Spinner';
import { useVerificationEmail } from '@/Domain/hooks/Auth/useVerificationEmail.hook';

const EmailVerificationPage = () => {
  const { t } = useTranslation(['email_verification', 'ERRORS']);

  const { handleResendClick, isPending, showResendMessage, apiError } = useVerificationEmail();

  return (
    <div className="text-center text-foreground">
      <h1 className="mb-8 text-center text-xl font-semibold text-foreground">{t('title')}</h1>
      <p className="text-muted-foreground">{t('link.send')}</p>
      <Button
        variant="dark"
        className="w-full mt-5"
        onClick={handleResendClick}
        disabled={isPending}
      >
        {isPending ? <Spinner /> : t('button.resend')}
      </Button>
      {showResendMessage && <p className="mt-2 text-base text-foreground">{t('link.reset')}</p>}
      {apiError != null && (
        <p className="mt-1 text-base text-destructive">{t(`ERRORS:${apiError}`)}</p>
      )}
    </div>
  );
};

export default EmailVerificationPage;
